<template>
    <div >
      <iframe allowfullscreen allow="fullscreen" :src="url" frameborder="0" v-if="url&&token" class="pageIframe" :class="{'fullscreen':fullscreen}"></iframe>
    </div>
  </template>
  
  <script>
  import {getIocToken} from "@/api/ioc/index"
  import {deepCopy} from "@/utils/vc"
  import { getCommunityId, getCommunityName,getCommunity } from '@/api/community/communityApi'
  import { getUserId,getUserName } from '@/api/user/userApi'
  export default {
    name: 'index',
    props: {
      // url: {
      //   type: String,
      //   default: ''
      // }
    },
    data() {
      return {
        url:this.$route.path,
        communityName:getCommunityName(),
        curCommunityId:getCommunityId(),
        userName:getUserName(),
        userId:getUserId(),
        community:getCommunity(),
        fullscreen:this.$route.path=='/screen',
        token:''
      }
    },
    created() {
      this._loadStoreInfo()
    },
    methods: {
      async _loadStoreInfo(){
        const res = await getIocToken()
        const token = res.data.token
        if (!token){
          return
        }
        this.token = token
        deepCopy(res)
        const url = this.$route.query.url
        console.log('url000000000000000000000')
        console.log(url)
        if (this.url=='/ioc/index'){
          this.url = '/'
        }
        if (process.env.NODE_ENV=='development'){
          this.url = `http://localhost:8002/thirdLogin?url=${this.url}&token=${token}&communityId=${this.curCommunityId}&username=${this.userName}&userid=${this.userId}&communitys=${JSON.stringify(this.community)}&communityName=${this.communityName}`
        } else {
          this.url = `https://yunding1st.cn:8788/thirdLogin?url=${this.url}&token=${token}&communityId=${this.curCommunityId}&username=${this.userName}&userid=${this.userId}&communitys=${JSON.stringify(this.community)}&communityName=${this.communityName}`
          // this.url = `http://192.168.1.12:8789/thirdLogin?url=${this.url}&token=${token}&communityId=${this.curCommunityId}&username=${this.userName}&userid=${this.userId}&communitys=${JSON.stringify(this.community)}&communityName=${this.communityName}`
        }
        // deepCopy(res,this.storeInfo);
      }
    }
  }
  </script>
  
  <style scoped>
  .pageIframe{
    width: 100%;
    height: calc(100vh - 50px);
    border: none;
}
.fullscreen{
  height:  calc(100vh - 4px);
  overflow: hidden;
}
  </style> 